import { requestJson } from "@/lib/api";

export interface DeliveryConfigDay {
  dayOfWeek: number; // ISO: 1=Mon … 7=Sun
  cutoffHour: number;
  active: boolean;
}

export const DAY_LABELS: Record<number, string> = {
  1: "Segunda-feira",
  2: "Terça-feira",
  3: "Quarta-feira",
  4: "Quinta-feira",
  5: "Sexta-feira",
  6: "Sábado",
  7: "Domingo",
};

export const DAY_SHORT: Record<number, string> = {
  1: "Seg",
  2: "Ter",
  3: "Qua",
  4: "Qui",
  5: "Sex",
  6: "Sáb",
  7: "Dom",
};

/** Fetches next `count` available delivery dates as ISO strings ("2026-04-22") */
export async function fetchAvailableDates(count = 14): Promise<string[]> {
  return requestJson<string[]>(`/api/v1/delivery/available-dates?count=${count}`);
}

/** Fetches full delivery configuration (ADMIN only) */
export async function fetchDeliveryConfig(): Promise<DeliveryConfigDay[]> {
  return requestJson<DeliveryConfigDay[]>("/api/v1/admin/config/delivery");
}

/** Updates delivery configuration (ADMIN only) */
export async function updateDeliveryConfig(config: DeliveryConfigDay[]): Promise<DeliveryConfigDay[]> {
  return requestJson<DeliveryConfigDay[]>("/api/v1/admin/config/delivery", {
    method: "PATCH",
    body: config,
  });
}
